import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AuthStateService } from 'src/app/core/auth/auth-state.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    providers: [MessageService]
})
export class LoginComponent {

    username!: string;

    password!: string;

    visible: boolean = false;

    loadingMessage!: string;

    loginForm!: FormGroup;

    screenWidth: number = 1200;

    constructor(public layoutService: LayoutService, private router: Router, private messageService: MessageService, private authStateService: AuthStateService, private fb: FormBuilder, private authService: AuthService) { }

    ngOnInit(): void {
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.onResize.bind(this));
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        })
    }

    onResize(event: Event) {
        this.screenWidth = window.innerWidth;
      }

    submitLoginForm(): void {
        this.loadingMessage = "Logging in";
        this.openDialog();
        this.authService.login(this.loginForm.get('username').value, this.loginForm.get('password').value).subscribe({
            next: value => {
                this.authStateService.setAuthTokenInfo(value);
                this.persistUserToState(this.authStateService.getDecodedAccessToken(value['access_token']))
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Login successful' });
                if (value['temporary_password'] !== null && value['temporary_password'] === true) {
                    this.closeDialog();
                    this.router.navigate(['/password-reset'], { queryParams: { data: JSON.stringify('') } })
                } else {
                    this.closeDialog();
                    this.router.navigate(['/home'])
                }
            },
            error: err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: "Login failed" });
                this.closeDialog();
            }
        })
    }

    persistUserToState(value: any): void {
        this.authStateService.setLoggedInUser(value)
    }

    openDialog(): void {
        this.visible = true;
    }

    closeDialog(): void {
        this.visible = false;
    }
}
